import React from 'react';
import NavbarLanding from '../components/NavbarLanding';
import Footer from './Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <NavbarLanding />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">
            Privacy Policy
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6 text-center">
              <strong>Last Updated:</strong> [Insert Date]
            </p>
            
            <p className="text-gray-700 mb-6">
              [Your Company Name] ("we," "our," "us") respects your privacy and is 
              committed to protecting it. This Privacy Policy explains how we collect, use, 
              and safeguard your information when you use our website and services. By 
              using our website, you agree to this Policy.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">
              Information We Collect
            </h2>
            
            <p className="text-gray-700 mb-4">
              We may collect:
            </p>
            
            <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
              <li>Personal details you provide (such as name, email, or account info) 
                  when you register, subscribe, or contact us.</li>
              <li>Responses you give in surveys or questionnaires.</li>
              <li>Technical data (like IP address, browser type, pages visited) through 
                  cookies or similar tools.</li>
            </ul>
            
            <p className="text-gray-700 mb-6">
              Some optional questions may include sensitive information (such as beliefs 
              or opinions). By answering, you consent to us processing that data.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">
              How We Use Your Information
            </h2>
            
            <p className="text-gray-700 mb-4">
              We use your information to:
            </p>
            
            <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
              <li>Provide and improve our services.</li>
              <li>Personalize your experience.</li>
              <li>Send updates, newsletters, or resources (only if you consent).</li>
              <li>Conduct research (using anonymized data).</li>
              <li>Keep our site secure and prevent misuse.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">
              How We Share Information
            </h2>
            
            <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
              <li>We never sell your personal data.</li>
              <li>We may share anonymized results for research.</li>
              <li>If you use a consultant or researcher's link, your data may be shared 
                  with them (with your consent).</li>
              <li>We may work with trusted third-party service providers to support our
                  operations.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">
              Cookies & Tracking
            </h2>
            
            <p className="text-gray-700 mb-6">
              We use cookies and analytics (like Google Analytics) to understand website 
              use and improve services. You can disable cookies in your browser, but 
              some features may not work correctly.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">
              Your Rights
            </h2>
            
            <p className="text-gray-700 mb-6">
              If you are in the EU/UK (GDPR): you can request access, correction, 
              deletion, or restriction of your data. You may also withdraw consent at any 
              time. Contact us to exercise these rights.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">
              Children's Privacy
            </h2>
            
            <p className="text-gray-700 mb-6">
              Our services are not for children under 13 (or 16 in the EU). Children may 
              only use assessments with parental or guardian supervision.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">
              Data Security
            </h2>
            
            <p className="text-gray-700 mb-6">
              We take reasonable measures to protect your information. You are 
              responsible for keeping your account credentials secure.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">
              Changes to This Policy
            </h2>
            
            <p className="text-gray-700 mb-6">
              We may update this Policy from time to time. The updated version will be 
              posted on this page with the revised date.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">
              Contact Us
            </h2>
            
            <p className="text-gray-700 mb-6">
              If you have questions or requests about this Policy, contact us at:
            </p>
            
            <p className="text-gray-700 mb-6">
              📧 [Your Contact Email]
            </p>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
